// extracted by mini-css-extract-plugin
module.exports = {"hero":"hero-module--hero--3c3vY","logo":"hero-module--logo--1kNz7","text":"hero-module--text--3xRxl"};